import { Heading, Text, VStack } from '@chakra-ui/react'

import { HeaderProps } from './types'

const Header = ({ title, subtitle }: HeaderProps) => {
  return (
    <VStack gap={4} alignItems="stretch" marginBottom={8}>
      <Heading 
        size="xl" 
        fontFamily="Montserrat" 
        fontWeight="600"
        bgGradient="linear(to-r, synthwave.400, brand.secondary)"
        bgClip="text"
        _hover={{ bgGradient: 'linear(to-r, synthwave.300, brand.secondary)' }}
      >
        {title}
      </Heading>
      <Text 
        fontSize="xl" 
        fontFamily="Roboto" 
        fontWeight="400"
        color="synthwave.200"
        _hover={{ color: 'synthwave.100' }}
      >
        {subtitle}
      </Text>
    </VStack>
  )
}

export default Header
